//
//
export default [
  {
    name: "contractCreatorExtern",
    path: "/contract",
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreatorExtern.vue"),
  },
  {
    name: "contractCreatorExternForm",
    path: "/contract/create/:id/:studioId",
    // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractCreator.vue"),
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
  {
    name: "contractCreatorExternForm",
    path: "/contract/create/:id/:studioId/:skipPresale",
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
]
